import { FormatType, KpkMedia, localStorageEffect } from "@keepeek/commons";
import { atom } from "recoil";

// Export formats selected
// Keep the two mode apart so we can maintain two persistence without interferring
// each other previous selection, the user will have two separated mode with two
// preferences in storage
export const downloadManagerSelectedFormatsByTypeState = atom<FormatType["id"][]>({
  key: "DownloadManagerSelectedFormatsByTypeState",
  default: [],
  effects: [localStorageEffect("DownloadManagerSelectedFormatsByTypeState")],
});

export type SelectedFormatByElement = {
  format: FormatType["id"];
  element: KpkMedia["id"];
};

export const downloadManagerSelectedFormatsByElementState = atom<SelectedFormatByElement[]>({
  key: "DownloadManagerSelectedFormatsByElementState",
  default: [],
  effects: [localStorageEffect("DownloadManagerSelectedFormatsByElementState")],
});
